import React from "react"

import ControlButtonMenu from "../../popover-menu/popup-menu-button/control-button-with-menu"
import CoverSelectorPopover from "./selector-popover"
import AttachmentsCollection from "../../../model2/attachment/attachments"
import {Cover} from "../../../model2/task/properties/cover"
import {CoverType} from "../cover-type"

type Props = {
    className?          : string
    type?               : 'icon' | 'label'
    cover?              : Cover
    attachments?        : AttachmentsCollection
    disabled?           : boolean

    onSelect?           : {(cover: Cover): void}
    onTogglePopover?    : {(value: boolean): void}
    enableAttachments?  : boolean
}

const debug = false
// const debug = "CoverSelector"

export default function CoverSelector(props: Props) {

    debug && console.log(debug, 'render', props)

    let iconClass, label
    switch (props.type) {
        case 'label':
            label = <div className="ui5-txt-not-important m-l-10 m-r-10">Change cover</div>
            break

        case 'icon' :
        default     :
            iconClass = 'i5-cover'
            break
    }

    return (
        <ControlButtonMenu className           = {props.className}
                           iconClass           = {iconClass}
                           menuComponent       = {CoverSelectorPopover}
                           offset              = "0 -8"
                           hint                = "Select cover"
                           menuParams={{
                               initialType       : CoverType.GALLERY,
                               cover             : props.cover,
                               attachments       : props.attachments,
                               onCoverSelected   : props.onSelect,
                               enableAttachments : props.enableAttachments
                           }}
                           clickOutsideDelay   = {0}
                           disabled            = {props.disabled}
                           onTogglePopover     = {props.onTogglePopover}>
            {label}
        </ControlButtonMenu>
    )
}
